// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".commentary_subtext-module__container--1PaV6{display:block;color:#616161;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}.commentary_subtext-module__paper--1D4QE{color:#616161}.commentary_subtext-module__item--FNKtC:not(:last-child)::after{content:' · '}.commentary_subtext-module__date--5qkg6{color:#303030;font-weight:400;font-size:14px;line-height:21px;letter-spacing:0}.commentary_subtext-module__datePaper--1gyCe{color:#616161}\n", ""]);
// Exports
exports.locals = {
	"container": "commentary_subtext-module__container--1PaV6",
	"paper": "commentary_subtext-module__paper--1D4QE",
	"item": "commentary_subtext-module__item--FNKtC",
	"date": "commentary_subtext-module__date--5qkg6",
	"datePaper": "commentary_subtext-module__datePaper--1gyCe"
};
module.exports = exports;
